import { render, staticRenderFns } from "./TableOverview.vue?vue&type=template&id=280267f9&scoped=true&"
import script from "./TableOverview.vue?vue&type=script&lang=js&"
export * from "./TableOverview.vue?vue&type=script&lang=js&"
import style0 from "./TableOverview.vue?vue&type=style&index=0&id=280267f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280267f9",
  null
  
)

export default component.exports